<div class="wd-100 ht-100 flex-col-container">
        <div class="flex-row-center m-t25 prop-container__header B">
            Plan Name
        </div>
        <div class="flex-row-center flex-1 m-t25">
            <div class="flex-col-container">
                <mat-form-field style="width:500px;">
                    <input  type="text" 
                    placeholder="Plan Name" 
                    aria-label="Plan Name" 
                    maxlength="40"
                    matInput
                    style="padding-left: 10px;"
                    [formControl]="planName">
                    <mat-hint align="end">{{planName.value.length}} / 40</mat-hint>
                    <button mat-button *ngIf="planName.value" matSuffix mat-icon-button aria-label="Clear" (click)="planName.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-error *ngIf="planName.invalid">* Please provide Plan Name</mat-error>
                </mat-form-field>
            </div>
        </div>
        <!-- <mat-divder></mat-divder> -->
        <div class="flex-row-end m-tb15 p-r25" >
            <span *ngIf="!isDataAvailable" class="error m-25">{{errorMsg}}</span> 
            <button mat-raised-button color="basic" (click)="closeDialog()" class="m-l10">Cancel</button>
            <button mat-raised-button color="primary" [disabled]="planName.invalid" (click)="savePlan()" class="m-l10">Save</button>            
            <!-- <button mat-raised-button [disabled]="planName.invalid" (click)="savePlan()" [ngClass]="!planName.invalid?'saveButton':'saveButton__disabled'" class="m-l5">Save</button> -->
        </div>    
</div>